import ProfileEdit from "./Profile/Edit";

import AddressesList from "./Addresses/List";
import AddressesSubmit from "./Addresses/Submit";

import PaymentMethodsList from "./Payment/List";
import PaymentMethodsSubmit from "./Payment/Submit";

import FavoritesList from "./Favorites/List";

import PointsList from "./Points/List";

import PromotionsList from "./Promotions/List";

import News from "./News/List";

import ProfileInfo from "./Profile/Info";

import OrdersList from "./Orders/List";

import Rewards from "./Rewards";

export default {
  ProfileInfo,
  ProfileEdit,
  AddressesList,
  AddressesSubmit,
  PaymentMethodsList,
  PaymentMethodsSubmit,
  OrdersList,
  FavoritesList,
  PointsList,
  PromotionsList,
  Rewards,
  News
};
